import React, { useState, useEffect } from 'react'
import Header from '../../../components/layout/header'
import LeftMenu from '../../../components/layout/leftMenu'
import { ToastContainer, toast } from "react-toastify";
import DesignationPopUp from './DesignationPopUp';
import Switch from "react-switch";
import { FiEdit } from "react-icons/fi";
import { backendApi } from '../../../api/apiService';

function Designations() {

  const [menuClick, setMenuClick] = useState(false);
  const [addDesignationPopup, setDesignationPopup] = useState(false);
  const [Data, setData] = useState([]);
  const [id, setid] = useState("");
  const [EditName, setEditName] = useState("")

  useEffect(() => {
    getAll();
  }, []);

  const getAll = () => {
    var req = {
      functionName: "designationAllList",
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(req).then((response) => {
      console.log('Status Results', response);
      if (response.success == 1) {
        console.log("req", response);
        setData(response.dataSet)
      } else {
        console.log("Error in status viewing.");
        return false;
      }
    });
  };


  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };

  const handleChange = (event, status) => {

    var req = {
      functionName: "designationActiveDeActive",
      id: status.id,
      is_active: event,
      updated_by: localStorage.getItem("userId")
    };
    console.log('activeDeactiveCandidateStatus', req);
    backendApi(req).then((response) => {
      if (response.success == 1) {
        toast.success("Status Changed successsfully", { containerId: "D" });
        getAll();
      }
      else {
        console.log("error while fetching openings");
        return false;
      }
    });
  };
  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <ToastContainer
        enableMultiContainer
        containerId={"D"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
      <div className="content-wrapper">
        <Header
          Header="Job Title"
          toggleMenu={toggleMenu}
          menuClick={menuClick}
        />
        <div className="card main-card">
          <div className="card-body">
            <div className="col-md-12">
              <div className="xilliWrap  table-wrap">
                <div className="row">
                  <div className="col-md-8 m-auto">
                    <div class="text-end mb-3">
                      <button
                        className="btn-btn btn btn-btn2 btn-sm ml-auto"
                        onClick={() => {
                          setDesignationPopup(true);
                          setid("");
                          setEditName("");
                        }}
                      >
                        New Job Title
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Sl.No</th>
                            <th>Job Title</th>
                            <th>Action</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Data.map((status, index) => (
                            <tr>
                              <td aria-label="Sl.No">{index + 1}</td>
                              <td aria-label="Title">{status.designation_name}</td>
                              <td aria-label="Action"><FiEdit className="text-primary"
                                onClick={() => {
                                  setid(status.id);
                                  setEditName(status.designation_name);
                                  setDesignationPopup(true);
                                }}
                              /></td>
                              <td aria-label="">
                                <Switch
                                  checked={
                                    status.is_active === 1
                                      ? true
                                      : false
                                  }
                                  onChange={(checked) => {
                                    handleChange(
                                      checked,
                                      status
                                    );
                                  }}
                                  width={40} height={18} /></td>
                            </tr>
                          ))}

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>

        {addDesignationPopup && (
          <DesignationPopUp
            onclose={() => setDesignationPopup(false)}
            onload={getAll}
            id={id}
            name={EditName}
          />
        )}
      </div>
    </div>
  )
}

export default Designations